import Vue from 'vue';
import Router from 'vue-router';
import { Screen } from 'quasar';
import Routes from './routes/routes';

Vue.use(Router);
const router = new Router({
  base: '/',
  mode: 'history',
  routes: Routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;

router.beforeEach((to, from, next) => {
  const urlsPublicas = ['/login', '/reject_notice_of_privacy'];
  const urlsMobile = ['/checklist', '/report', '/reception'];
  const urlsMobileToReload = ['/inventario', '/checklist', '/payment_order', '/reception', '/report', '/detail', '/conditions', '/invoices'];
  const isMobile = urlsMobile.includes(to.path);
  const logueado = router.app.$session.get('orderId');

  if (Screen.gt.sm && isMobile) {
    next({ path: '/home' });
  }

  if (urlsPublicas.indexOf(to.path) >= 0 && logueado) {
    next({ path: '/home' });
  }

  if (typeof Vue.prototype.ultimaNotificacion === 'function') {
    Vue.prototype.ultimaNotificacion();
  }

  if (
    from.fullPath === '/'
    && (
      urlsMobileToReload.indexOf(to.path) >= 0
      || to.fullPath.includes('/report/')
      || to.fullPath.includes('/detail/')
      || to.fullPath.includes('/show_pdf/')
    )
  ) {
    // Redirect to home if you reload/F5 in mobile
    // while in any route inside urlsMobileToReload
    // or include /report or /detail , etc will redirect to home
    next('/home');
  }

  next();
});
